export const StepBlock = ({ index, children }) => {
  return (
    <li
      className="relative pl-16 sm:pl-20 py-4 group"
      data-testid={`step-block-${index}`}
    >
      <span
        aria-hidden
        className="absolute left-0 top-2 font-mono font-black text-4xl sm:text-5xl leading-none text-foreground/15 group-hover:text-brut-yellow transition-colors duration-150 select-none"
      >
        {String(index).padStart(2, "0")}
      </span>
      <span
        aria-hidden
        className="absolute left-12 sm:left-16 top-3 bottom-3 w-[2px] bg-foreground/15 group-hover:bg-foreground/40 transition-colors"
      />
      <p className="text-base sm:text-lg leading-relaxed">{children}</p>
    </li>
  );
};
